export enum UserTab {
    Account = "USER_ACCOUNT_TAB",
    Appearance = "USER_APPEARANCE_TAB",
    Notifications = "USER_NOTIFICATIONS_TAB",
    Preferences = "USER_PREFERENCES_TAB",
    Keyboard = "USER_KEYBOARD_TAB",
    Sidebar = "USER_SIDEBAR_TAB",
    Voice = "USER_VOICE_TAB",
    Security = "USER_SECURITY_TAB",
    Encryption = "USER_ENCRYPTION_TAB",
    Labs = "USER_LABS_TAB",
    // Mjolnir = "USER_MJOLNIR_TAB",
    Help = "USER_HELP_TAB",
    SessionManager = "USER_SESSION_MANAGER_TAB",
    Contact = "USER_FORMAT_CONTACTS"
}
